module.exports = __webpack_public_path__ + "static/img/gsjj.a8b6874.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/gsjj.png
// module id = /Ct9
// module chunks = 0